import { Eye, Wind, Sun } from "lucide-react";
import { motion } from "framer-motion";
import { STEPS } from "@/lib/content";
import { SectionHead } from "@/components/site/SectionHead";

const ICONS = { perceive: Eye, release: Wind, reconnect: Sun };
const ORBS = {
  perceive: "bg-[#2a2420] text-[#e8dccb]",
  release: "bg-[linear-gradient(90deg,#2a2420_50%,#e7e1d8_50%)] text-[#faf5ee]",
  reconnect: "bg-[radial-gradient(circle,#f6dc9a_0%,#d4a64a_55%,#a8792a_100%)] text-[#3b2a0e]",
};

const StepCard = ({ step, i }) => {
  const Icon = ICONS[step.key];
  return (
    <motion.article
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -6 }}
      data-testid={`step-card-${step.key}`}
      className="group relative flex flex-col rounded-[1.75rem] border border-[#e4dacb] bg-[#fffaf3] p-8 transition-shadow duration-500 hover:shadow-[0_30px_60px_-35px_rgba(34,30,27,0.35)] lg:p-10"
    >
      <div className="flex items-center justify-between">
        <span className={`flex h-14 w-14 items-center justify-center rounded-full ${ORBS[step.key]}`}>
          <Icon className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <span className="font-display text-5xl text-[#221e1b]/15">0{i + 1}</span>
      </div>
      <h3 className="font-display mt-10 text-4xl text-[#221e1b]">{step.word}</h3>
      <p className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#7a5615]">{step.through}</p>
      <p className="mt-5 text-[0.98rem] leading-relaxed text-[#5d544c]">{step.text}</p>
    </motion.article>
  );
};

export const StepsSection = () => (
  <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8 md:py-32 lg:px-12" data-testid="steps-section">
    <SectionHead
      eyebrow="The heart of Panchmaya"
      title={<>Three movements, <em>from carrying to clarity</em></>}
      text="Rather than adding more information, Panchmaya moves gently in three directions: noticing, letting go, and coming home to yourself."
    />
    <div className="mt-16 grid gap-6 md:grid-cols-3">
      {STEPS.map((s, i) => <StepCard key={s.key} step={s} i={i} />)}
    </div>
  </section>
);
